import React from 'react';
import { X } from 'lucide-react';

const GlossaryModal = ({ term, onClose }) => {
  if (!term) return null;

  return (
    <div className="glossary-modal-overlay" onClick={onClose}>
      <div className="glossary-modal" onClick={(e) => e.stopPropagation()}>
        <div className="glossary-modal-header">
          <div>
            <h2>{term.term}</h2>
            <span className="glossary-category">{term.category}</span>
          </div>
          <button className="close-button" onClick={onClose} aria-label="Close">
            <X size={24} />
          </button>
        </div>
        
        <div className="glossary-modal-content">
          <div className="glossary-section">
            <h3>Definition</h3>
            <p>{term.definition}</p>
          </div>
          
          {term.example && (
            <div className="glossary-section">
              <h3>Example</h3>
              <p className="glossary-example">{term.example}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default GlossaryModal;
